import firebase from "../../config/firebase";
import algoliasearch from "algoliasearch";
import { createNullCache } from "@algolia/cache-common";
import { toast } from "react-toastify";
const client = algoliasearch("GPYJEAVUBP", "b1f999bc5b264defe930762391d240c6", {
  responsesCache: createNullCache(),
});

export const onRequestCreate =
  (onSuccess = () => {}) =>
  async () => {
    try {
      firebase
        .firestore()
        .collection("requests")
        .onSnapshot(() => onSuccess());
    } catch (err) {
      console.error("Error while triggering request change:", err.message);
    }
  };

export const fetchEasyPaisaDetails = () => async (dispatch) => {
  try {
    const db = firebase.firestore();
    const docRef = db.collection("adminDetails").doc("easypaisa");
    const docSnapshot = await docRef.get();
    if (docSnapshot.exists) {
      dispatch({ type: "UPDATE_EASYPAISA", payload: docSnapshot.data() });
    } else {
      console.warning("EasyPaisa details not found in Firestore.");
      dispatch({ type: "UPDATE_EASYPAISA", payload: {} });
    }
  } catch (error) {
    console.error("Error fetching EasyPaisa details:", error);
    toast.error("Error fetching EasyPaisa details.");
  }
};

export const updateEasyPaisaDetails = (formData) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_EASYPAISA_LOADER", payload: true });
    const db = firebase.firestore();
    const docRef = db.collection("adminDetails").doc("easypaisa");
    const docSnapshot = await docRef.get();
    if (docSnapshot.exists) {
      await docRef.set(formData, { merge: true });
      toast.success("EasyPaisa details updated successfully.");
    } else {
      await docRef.set(formData);
      toast.success("EasyPaisa details created successfully.");
    }
    dispatch({ type: "UPDATE_EASYPAISA", payload: formData });
  } catch (error) {
    console.error("Error updating/creating EasyPaisa details:", error);
    toast.error("Error updating/creating EasyPaisa details.");
  } finally {
    dispatch({ type: "UPDATE_EASYPAISA_LOADER", payload: false });
  }
};

export const getRequests =
  (id, hitsPerPage, currentPage, searchTerm) => async (dispatch) => {
    try {
      dispatch({ type: "SET_LOADER", payload: true });

      // Calculate 24 hours ago timestamp in seconds
      const twentyFourHoursAgo = Math.floor(Date.now() / 1000) - 24 * 60 * 60;
      const currentTimestamp = Math.floor(Date.now() / 1000);

      const index = client.initIndex("requests");
      index
        .search(searchTerm, {
          filters: `restaurantID:${id} AND (createdAt._seconds >= ${twentyFourHoursAgo} AND createdAt._seconds <= ${currentTimestamp}) AND status:processing`,
          hitsPerPage: hitsPerPage,
          page: currentPage,
        })
        .then((response) => {
          dispatch({ type: "GET_ALL_REQUESTS", payload: response });
          dispatch({ type: "SET_LOADER", payload: false });
        })
        .catch((err) => {
          console.error("Search error:", err.message);
          dispatch({ type: "SET_LOADER", payload: false });
        });
    } catch (err) {
      console.error("Snapshot error:", err.message);
    }
  };

export const updateRequest = (id, status) => async (dispatch) => {
  try {
    dispatch({ type: "UPDATE_LOADER", payload: true });
    await firebase.firestore().collection("requests").doc(id).update({
      status,
    });
    dispatch({ type: "UPDATE_REQUESTS", payload: id });
  } catch (err) {
    toast.error(err.message || "Unable to update request");
    console.error(err.message);
  } finally {
    dispatch({ type: "UPDATE_LOADER", payload: false });
  }
};
export const getAllOrders =
  (
    search,
    id,
    currentPage,
    startDate,
    endDate,
    minValue,
    maxValue,
    orderType,
    filterValue,
    onSuccess = () => {},
    isWaiter = false
  ) =>
  async (dispatch) => {
    const orderIndex = client.initIndex("orders");
    let amountFilter = "";

    if (minValue !== undefined && maxValue !== undefined) {
      amountFilter = ` AND (totalAmount >= ${minValue} AND totalAmount <= ${maxValue})`;
    } else if (minValue !== undefined) {
      amountFilter = ` AND totalAmount >= ${minValue}`;
    } else if (maxValue !== undefined) {
      amountFilter = ` AND totalAmount <= ${maxValue}`;
    }

    let status = filterValue ? ` AND (status:${filterValue})` : "";
    let orderTypeFilter = orderType ? ` AND (orderType:${orderType})` : "";

    const fetchOrders = async () => {
      try {
        const response = await orderIndex.search(search, {
          filters: `${
            isWaiter ? "waiterID" : "restaurantID"
          }:${id} AND (createdAt._seconds > ${startDate} AND createdAt._seconds < ${endDate}) ${amountFilter}${status}${orderTypeFilter}`,
          page: currentPage,
        });

        let { hits, ...rest } = response;

        dispatch({ type: "ORDERS", payload: hits });
        dispatch({ type: "ORDERS_DETAILS", payload: rest });

        dispatch(orderLoader(false));
        onSuccess();
      } catch (error) {
        console.error("Error fetching orders: ", error);
        dispatch(orderLoader(false));
      }
    };

    const unsubscribe = firebase
      .firestore()
      .collection("orders")
      .where(isWaiter ? "waiterID" : "restaurantID", "==", id)
      .onSnapshot(() => {
        fetchOrders();
      });

    return unsubscribe;
  };

const updateOrderLoader = (data) => async (dispatch) => {
  dispatch({
    type: "UPDATE_ORDER_LOADER",
    payload: data,
  });
};

export const updateOrder = (item, status, onSuccess) => async (dispatch) => {
  dispatch(updateOrderLoader({ orderId: item.id, loading: true }));

  try {
    await firebase.firestore().collection("orders").doc(item?.id).update({
      status: status,
    });

    dispatch({
      type: "UPDATE_ORDER_STATUS",
      payload: { id: item.id, status: status },
    });

    dispatch({ type: "CLEAR_TABLE_STATE", payload: item?.id });
  } catch (error) {
    console.error("Order update failed:", error.message);
  } finally {
    setTimeout(() => {
      dispatch(updateOrderLoader({ orderId: item.id, loading: false }));
      onSuccess?.();
    }, 5000);
  }
};

const unreadLoader = (data) => async (dispatch) => {
  dispatch({
    type: "UNREAD_LOADER",
    payload: data,
  });
};

export const getUnreadNotfications = (id) => async (dispatch) => {
  try {
    dispatch(unreadLoader(true));

    if (!id) return;
    const unsubscribe = firebase
      .firestore()
      .collection("notifications")
      .where("restaurantID", "==", id)
      .where("markAsRead", "==", false)
      .orderBy("createdAt", "desc")
      .limit(5)
      .onSnapshot(async (query) => {
        let unread = [];

        for (let doc of query.docs) {
          const customerId = doc.data().customerID;
          let imageUrl = null;
          let name = "Unknown";

          if (customerId) {
            const customerSnapShot = firebase
              .firestore()
              .collection("users")
              .doc(customerId);

            const customerDoc = await customerSnapShot.get();

            if (customerDoc.exists) {
              const customerData = customerDoc.data();
              imageUrl = customerData?.imageURL || null;
              name = customerData?.name || "Unknown";
            }
          }
          unread.push({ id: doc.id, imageUrl, name, ...doc.data() });
        }

        dispatch(unreadLoader(false));
        dispatch({
          type: "UNREAD_NOTFICATIONS",
          payload: unread,
        });
      });
    return unsubscribe;
  } catch (err) {
    console.error(err);

    dispatch(unreadLoader(false));
    toast.error(err.message);
  }
};

const readNotificationLoader = (data) => async (dispatch) => {
  dispatch({
    type: "NOTIFICATION_LOADER",
    payload: data,
  });
};

export const updateNotification =
  (restaurantID, notificationID) => async (dispatch) => {
    try {
      dispatch(readNotificationLoader(true));
      const notificationsRef = firebase.firestore().collection("notifications");
      const querySnapshot = await notificationsRef
        .where("restaurantID", "==", restaurantID)
        .where(firebase.firestore.FieldPath.documentId(), "==", notificationID)
        .get();

      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          doc.ref.delete();
        });
        dispatch(readNotificationLoader(false));
        toast.success("Notification read successfully");
      } else {
        dispatch(readNotificationLoader(false));
        toast.error("Notification not found for this restaurant");
      }
    } catch (error) {
      dispatch(readNotificationLoader(false));
      console.error("Error updating/deleting notification:", error);
      toast.error("Error deleting notification");
    }
  };

const clearAllLoader = (data) => async (dispatch) => {
  dispatch({
    type: "CLEAR_ALL_LOADER",
    payload: data,
  });
};

export const clearAllNotifications = (id) => async (dispatch) => {
  try {
    dispatch(clearAllLoader(true));
    const notificationsRef = firebase.firestore().collection("notifications");

    const querySnapshot = await notificationsRef
      .where("restaurantID", "==", id)
      .get();

    const batch = firebase.firestore().batch();

    querySnapshot.forEach((doc) => {
      if (doc.exists) {
        batch.delete(doc.ref);
      }
    });

    await batch.commit();
    dispatch(clearAllLoader(false));
    toast.success("All Notifications Cleared");
  } catch (error) {
    dispatch(clearAllLoader(false));
    console.error("Error clearing notifications:", error);
    toast.error("Error clearing notifications");
  }
};

const getNotificationsLoader = (data) => async (dispatch) => {
  dispatch({
    type: "GET_NOTIFICATIONS_LOADER",
    payload: data,
  });
};
export const getNotifications = (id) => async (dispatch) => {
  try {
    dispatch(getNotificationsLoader(true));
    firebase
      .firestore()
      .collection("notifications")
      .where("restaurantID", "==", id)
      .where("markAsRead", "==", false)
      .limit(15)
      .orderBy("createdAt", "desc")
      .onSnapshot(async (query) => {
        let unread = [];

        const customerPromises = query.docs.map(async (doc) => {
          const customerId = doc.data().customerID;
          const customerSnapShot = firebase
            .firestore()
            .collection("users")
            .doc(customerId);
          const customerDoc = await customerSnapShot.get();
          const customerData = customerDoc.data();
          const { imageURL, name } = customerData;
          unread.push({ id: doc.id, imageURL, name, ...doc.data() });
        });
        await Promise.all(customerPromises);

        dispatch({
          type: "ALL_NOTIFICATIONS",
          payload: unread,
        });

        dispatch(getNotificationsLoader(false));
      });
  } catch (err) {
    dispatch(getNotificationsLoader(false));
    toast.error(err.message);
  }
};

const getNextLoader = (data) => async (dispatch) => {
  dispatch({
    type: "GET_NEXT_LOADER",
    payload: data,
  });
};

export const getNextNotifications =
  (id, object, onSuccess = () => {}) =>
  async (dispatch, getState) => {
    try {
      dispatch(getNextLoader(true));
      const querySnapshot = await firebase
        .firestore()
        .collection("notifications")
        .where("restaurantID", "==", id)
        .orderBy("createdAt", "desc")
        .startAfter(object?.createdAt || null)
        .limit(15)
        .get();

      let unread = [];
      const customerPromises = querySnapshot.docs.map(async (doc) => {
        const customerId = doc.data().customerID;
        const customerSnapShot = firebase
          .firestore()
          .collection("users")
          .doc(customerId);
        const customerDoc = await customerSnapShot.get();
        const customerData = customerDoc.data();

        const { imageUrl, name } = customerData;

        unread.push({ id: doc.id, imageUrl, name, ...doc.data() });
      });

      await Promise.all(customerPromises);

      const { allNotifications } = getState().requests;
      const updatedNotifications = [...allNotifications, ...unread];

      dispatch({
        type: "ALL_NOTIFICATIONS",
        payload: updatedNotifications,
      });

      dispatch(getNextLoader(false));

      onSuccess(unread);
    } catch (err) {
      toast.error(err.message);
      dispatch(getNextLoader(false));
    }
  };

export const orderLoader = (val) => async (dispatch) => {
  dispatch({
    type: "ORDER_LOADER",
    payload: val,
  });
};

export const getSubscriptionRequests =
  ({ onComplete = () => {} }) =>
  async (dispatch) => {
    try {
      const query = firebase
        .firestore()
        .collection("subscriptions")
        .where("status", "==", "pending")
        .orderBy("createdAt", "desc")
        .limit(5);
      query.onSnapshot((snapshot) => {
        const subscriptionRequests = snapshot.docs.map((doc) => doc.data());
        dispatch({
          type: "GET_SUBSCRIPTION_REQUESTS",
          payload: subscriptionRequests,
        });
        onComplete();
      });
    } catch (error) {
      console.error(error.message || "An unknown error has occurred.");
      toast.error(error.message || "An unknown error has occurred.");
      onComplete();
    }
  };

export const acceptSubscriptionRequest =
  ({
    id,
    subscriptionType,
    imageUrl,
    startDate = "",
    onSuccess = () => {},
    onError = () => {},
  }) =>
  async () => {
    try {
      const today = firebase.firestore.Timestamp.now();
      let endDate = null;
      if (subscriptionType === "monthly") {
        endDate = firebase.firestore.Timestamp.fromDate(
          new Date(today.toDate().setMonth(today.toDate().getMonth() + 1))
        );
      } else if (subscriptionType === "yearly") {
        endDate = firebase.firestore.Timestamp.fromDate(
          new Date(today.toDate().setFullYear(today.toDate().getFullYear() + 1))
        );
      }

      await firebase
        .firestore()
        .collection("users")
        .doc(id)
        .update({
          easypaisaSubscription: {
            status: "active",
            type: subscriptionType,
            startDate: startDate ? startDate : today,
            endDate,
            isDowngraded: false,
          },
          subScriptionStatus: "subscribe",
        });

      await firebase.firestore().collection("subscriptions").doc(id).update({
        status: "accepted",
      });

      toast.success("Subscription accepted successfully.");
      onSuccess();
    } catch (error) {
      console.error(error.message || "An unknown error has occurred.");
      toast.error(error.message || "An unknown error has occurred.");
      onError();
    }
  };

export const downgradeSubscription =
  ({ id, onSuccess = () => {}, onError = () => {} }) =>
  async () => {
    try {
      await firebase.firestore().collection("users").doc(id).update({
        "easypaisaSubscription.isDowngraded": true,
      });
      await firebase.firestore().collection("subscriptions").doc(id).update({
        status: "accepted",
      });
      toast.success("Subscription downgraded successfully.");
      onSuccess();
    } catch (error) {
      console.error(error.message || "An unknown error has occurred.");
      toast.error(error.message || "An unknown error has occurred.");
      onError();
    }
  };

export const rejectSubscriptionRequest =
  ({ id, imageUrl, onSuccess = () => {}, onError = () => {} }) =>
  async () => {
    try {
      await firebase.firestore().collection("subscriptions").doc(id).update({
        status: "rejected",
      });
      toast.success("Subscription request rejected successfully.");
      onSuccess();
    } catch (error) {
      console.error(error.message || "An unknown error has occurred.");
      toast.error(error.message || "An unknown error has occurred.");
      onError();
    }
  };

export const cancelEasypaisaSubscription =
  ({ id, onSuccess = () => {}, onError = () => {} }) =>
  async () => {
    try {
      await firebase.firestore().collection("users").doc(id).update({
        easypaisaSubscription: firebase.firestore.FieldValue.delete(),
        subScriptionStatus: "unsubscribe",
      });
      await firebase.firestore().collection("subscriptions").doc(id).delete();
      toast.success("Subscription cancelled successfully.");
      onSuccess();
    } catch (error) {
      console.error(error.message || "An unknown error has occurred.");
      toast.error(error.message || "An unknown error has occurred.");
      onError();
    }
  };
